import React from "react"
import PropTypes from "prop-types"

import styles from "./navitem-caption.module.css"

export const NavItemCaption = ({ children, ...props }) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  return (
    <div {...rest} className={styles.NavItemCaption}>
      {children}
    </div>
  )
}

NavItemCaption.displayName = "NavItemCaption"

NavItemCaption.propTypes = {
  /**
   * React node to render the caption of the nav item.
   */
  children: PropTypes.node,
}
